import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Icon } from "@iconify/react";

gsap.registerPlugin(ScrollTrigger);

const services = [
  {
    id: 1,
    icon: "material-symbols:interactive-space",
    title: "No More Interview Glitches",
    desc: "High-quality, stable video and audio interviews built for Dubai’s professional hiring standards.",
  },
  {
    id: 2,
    icon: "material-symbols:wand-stars-outline",
    title: "AI at the Core",
    desc: "From screening to shortlisting, AI automates hiring while reducing recruiter workload.",
  },
  {
    id: 3,
    icon: "material-symbols:lab-profile-outline",
    title: "Smarter Candidate Profiles",
    desc: "Go beyond resumes and identify skills, strengths, and role fit instantly.",
  },
  {
    id: 4,
    icon: "material-symbols:settings-applications",
    title: "Protection Against Fake Applications",
    desc: "Every profile is verified to ensure safe, authentic hiring.",
  },
  {
    id: 5,
    icon: "material-symbols:data-usage-rounded",
    title: "Data-Driven Hiring Decisions",
    desc: "Access analytics and insights to hire smarter and faster in the UAE market.",
  },
  {
    id: 6,
    icon: "material-symbols:floor",
    title: "Inclusive & Fair Hiring",
    desc: "Promoting unbiased, diverse, and inclusive recruitment practices across Dubai.",
  },
];

export default function ServicesSection() {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        sectionRef.current.querySelectorAll(".animate-text"),
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          stagger: 0.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
      gsap.fromTo(
        cardsRef.current,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 75%",
            toggleActions: "play none none reverse",
          },
        }
      );
    })
    return () => ctx.revert();

  }, []);

  return (
    <>

      <section id="services"
        ref={sectionRef}
        className="bg-black text-white py-12 px-6 md:px-20 overflow-hidden"
      >
        {/* Tag */}
        <div className="flex justify-start mb-6">

          <button className="bg-white/10 border border-white/20 px-4 sm:px-6 py-2  rounded-full text-xs sm:text-sm hover:bg-white/20 transition-all flex items-center">
            <Icon
              icon="material-symbols:lightbulb-2-rounded"
              className="mr-2 text-[#F26A33] drop-shadow-[0_0_8px_#F26A33]"
              width="22"
              height="22"
            />
            WHAT SERVICES WE PROVIDE

          </button>
        </div>

        {/* Heading */}
        <h2 className="animate-text text-4xl lg:text-4xl xl:text-7xl font-light text-gray-400 md:mb-4 leading-tight">
          Digital Hiring{" "}
          <span className="text-white font-light">Services Aligned</span>
        </h2>
        <h2 className="animate-text text-4xl lg:text-4xl xl:text-7xl font-light text-white leading-tight mb-4">
          With Your Goals
        </h2>


        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 w-full fade-up md:py-16 py-6">
          {services.map((service, index) => (
            <div
              key={service.id}
              ref={(el) => (cardsRef.current[index] = el)}
              className="bg-neutral-900 md:p-12 p-4 border border-neutral-800 hover:border-orange-500 transition-all duration-300 group"
            >
              <Icon icon={service.icon} className="md:text-5xl text-4xl mb-4 text-orange-500 " />
              {/* <div className="text-4xl mb-4 text-orange-500">{service.icon}</div> */}
              <h3 className="md:text-3xl font-semibold mb-3 group-hover:text-orange-500 transition-all">
                {service.title}
              </h3>
              <p className="text-gray-400 text-lg leading-relaxed">{service.desc}</p>
            </div>
          ))}
        </div>
      </section>





      {/* <section
        ref={sectionRef}
        className="bg-black text-white px-6 md:px-16 py-24 flex flex-col lg:flex-row items-start justify-between gap-12"
      >
        <div className="w-full lg:w-1/2 fade-up">
          <button className="bg-neutral-800 text-gray-300 px-6 py-2 rounded-full text-sm mb-6">
            What Services We Provide
          </button>
          <h1 className="text-5xl md:text-7xl font-light leading-snug text-gray-400">
            Digital marketing{" "}
            <span className="text-white font-normal">
              services aligned with your goals
            </span>
          </h1>

          <div className="text-center pt-12">
            <img className="h-[400px] w-[400px]" src="https://wp.codeefly.net/metech/wp-content/uploads/2025/09/arrow-top-icon-2.png" alt="" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 w-full lg:w-2/3 fade-up">
          {services.map((service, index) => (
            <div
              key={service.id}
              ref={(el) => (cardsRef.current[index] = el)}
              className="bg-neutral-900 p-12 border border-neutral-800 hover:border-orange-500 transition-all duration-300 group"
            >
              <div className="text-4xl mb-4 text-orange-500">{service.icon}</div>
              <h3 className="text-3xl font-semibold mb-3 group-hover:text-orange-500 transition-all">
                {service.title}
              </h3>
              <p className="text-gray-400 text-lg leading-relaxed">{service.desc}</p>
            </div>
          ))}
        </div>
      </section> */}
    </>



  );
}
